const DEFAULT_LOCALE = "id";

const messages = {
  id: {
    nav: {
      program: "Program",
      faq: "FAQ",
      blog: "Blog",
      terms: "Syarat dan Ketentuan",
      certificate: "Verifikasi Sertifikat",
      contact: "Kontak",
      whatsapp: "WhatsApp Kami",
      language: "Ganti bahasa",
    },
    hero: {
      badge: "#1 Les Privat di Indonesia",
      titleBefore: "Guru Les Privat",
      home: "Ke Rumah",
      or: "atau",
      online: "Online",
      description: "Untuk PAUD, TK, SD, SMP, SMA, Bahasa Asing (Inggris, Mandarin, Jepang, Jerman, Arab), Renang, Komputer, Koding, Mengaji, dan banyak lagi.",
      promotion: "Gratis Registrasi + Voucher 50.000!",
      consultation: "Gratis Konsultasi",
      demo: "Lihat Demo",
      download: "Download Aplikasi Kami",
      freeRegistration: "Gratis Registrasi",
      flexibleSchedule: "Jadwal Fleksibel",
      chooseTutor: "Bisa Pilih Guru",
      students: "2000+ Siswa",
      imageAlt: "Tutor InstaPrivat mendampingi siswa belajar",
      whatsappMessage: "Halo InstaPrivat, saya ingin konsultasi les privat.",
    },
    home: {
      achievementsTitle: "Pencapaian Kami",
      achievementsSubtitle: "Dipercaya oleh siswa dan keluarga untuk mendukung perjalanan belajar mereka.",
      achievementLabels: ["Siswa Terdaftar", "Guru Ahli", "Mata Pelajaran", "Tahun Pengalaman"],
      helpTitle: "Apa yang Bisa Kami Bantu?",
      helpSubtitle: "Temukan tutor berkualitas untuk setiap jenjang, minat, dan tujuan belajar Anda.",
      privateLesson: "Les Privat",
      subjects: ["PAUD & TK", "SD", "SMP", "SMA", "Bahasa Asing", "Komputer", "Koding", "Mengaji", "Renang", "SBMPTN", "Musik", "Dan Lainnya"],
      programsTitle: "Program Kami",
      programsSubtitle: "Pilih program belajar yang sesuai dengan kebutuhan Anda.",
      readMore: "Lihat Selengkapnya",
      viewMore: "Lihat Program Lainnya",
      featuredTitle: "Tutor Unggulan Kami",
      featuredSubtitle: "Belajar bersama tutor pilihan InstaPrivat yang berpengalaman dan berkualitas.",
      featured: "Unggulan",
      subjectsLabel: "Mata Pelajaran",
      curriculum: "Kurikulum",
      location: "Lokasi",
      unavailable: "Belum tersedia",
      bookNow: "Pesan Sekarang",
      ctaTitle: "Siap Meningkatkan Prestasi Belajar?",
      ctaText: "Daftar sekarang dan dapatkan guru les privat terbaik untuk Anda. Konsultasi gratis!",
      freeConsultation: "Konsultasi Gratis",
      chat: "Chat Kami",
    },
    demo: {
      title: "Demonstrasi Bimbingan Belajar",
      subtitle: "Tonton bagaimana proses belajar mengajar bersama guru profesional kami.",
    },
    testimonials: {
      title: "Apa Kata Mereka?",
      subtitle: "9 dari 10 siswa kami puas dengan pengajaran tutor kami.",
    },
    footer: {
      description: "Temukan tutor terbaik untuk pelajaran sekolah, bahasa asing, mengaji, persiapan universitas, komputer, koding, dan berbagai kebutuhan belajar lainnya.",
      download: "Download aplikasi kami",
      connect: "Terhubung dengan kami",
      follow: "Ikuti InstaPrivat",
      followText: "Dapatkan informasi program, tips belajar, dan kabar terbaru.",
      validate: "Validasi dokumen",
      verify: "Verifikasi Sertifikat",
      ready: "Kami siap membantu",
      contact: "Hubungi Kami",
      hours: "Jam Operasional",
      weekdays: "Senin–Jumat, 09.00–17.00 WIB",
      weekend: "Sabtu–Minggu tutup",
      tangerang: "Kantor Tangerang",
      yogyakarta: "Kantor Yogyakarta",
      rights: "© 2020–2026. Seluruh hak cipta dilindungi.",
    },
    programs: {
      loading: "Memuat program...",
      error: "Program belum dapat ditampilkan.",
      empty: "Program belum tersedia.",
      readMore: "Lihat selengkapnya",
      book: "Pesan Sekarang",
      whatsappMessage: "Halo InstaPrivat, saya ingin memesan program {title}.",
    },
    terms: {
      title: "Syarat dan Ketentuan Siswa",
      subtitle: "Ketentuan layanan untuk siswa dan orang tua siswa InstaPrivat.",
      loading: "Memuat syarat dan ketentuan...",
      error: "Syarat dan ketentuan belum dapat ditampilkan.",
    },
    certificate: {
      official: "Layanan Resmi InstaPrivat",
      title: "Verifikasi Sertifikat",
      subtitle: "Pastikan keaslian sertifikat siswa atau tutor dengan memasukkan ID sertifikat yang tertera pada dokumen.",
      security: "Hasil verifikasi ditampilkan langsung dari sistem InstaPrivat.",
      studentTab: "Siswa",
      tutorTab: "Tutor",
      studentTitle: "Verifikasi Sertifikat Siswa",
      tutorTitle: "Verifikasi Sertifikat Tutor",
      studentHint: "Masukkan ID sertifikat siswa persis seperti yang tertulis pada dokumen.",
      tutorHint: "Masukkan ID sertifikat tutor persis seperti yang tertulis pada dokumen.",
      studentId: "ID Sertifikat Siswa",
      tutorId: "ID Sertifikat Tutor",
      studentPlaceholder: "Contoh: STU-CERT-12345",
      tutorPlaceholder: "Contoh: TUT-CERT-12345",
      checking: "Sedang memeriksa...",
      verifyNow: "Verifikasi Sekarang",
      valid: "Sertifikat Valid",
      validDescription: "Sertifikat ini tercatat secara resmi di sistem InstaPrivat.",
      certificateId: "ID Sertifikat",
      userStudentId: "ID Siswa",
      userTutorId: "ID Tutor",
      totalClasses: "Total Kelas",
      studentSummary: "Siswa telah mengikuti {count} kelas bersama InstaPrivat.",
      tutorSummary: "Tutor telah mengajar {count} kelas bersama InstaPrivat.",
      notFound: "Sertifikat Tidak Ditemukan",
      studentNotFound: "Tidak ada sertifikat siswa dengan ID {id}. Periksa kembali ID lalu coba lagi.",
      tutorNotFound: "Tidak ada sertifikat tutor dengan ID {id}. Periksa kembali ID lalu coba lagi.",
      requestError: "Verifikasi belum dapat diproses. Silakan coba beberapa saat lagi.",
    },
  },
  en: {
    nav: {
      program: "Programs",
      faq: "FAQ",
      blog: "Blog",
      terms: "Terms & Conditions",
      certificate: "Certificate Verification",
      contact: "Contact",
      whatsapp: "Chat on WhatsApp",
      language: "Change language",
    },
    hero: {
      badge: "#1 Private Tutoring in Indonesia",
      titleBefore: "Private Tutors",
      home: "At Home",
      or: "or",
      online: "Online",
      description: "For preschool, elementary, junior and senior high school, foreign languages, swimming, computers, coding, Quran lessons, and much more.",
      promotion: "Free Registration + IDR 50,000 Voucher!",
      consultation: "Free Consultation",
      demo: "Watch Demo",
      download: "Download Our App",
      freeRegistration: "Free Registration",
      flexibleSchedule: "Flexible Schedule",
      chooseTutor: "Choose Your Tutor",
      students: "2000+ Students",
      imageAlt: "An InstaPrivat tutor helping a student learn",
      whatsappMessage: "Hello InstaPrivat, I would like a private tutoring consultation.",
    },
    home: {
      achievementsTitle: "Our Achievements",
      achievementsSubtitle: "Trusted by students and families throughout their learning journey.",
      achievementLabels: ["Registered Students", "Expert Tutors", "Subjects", "Years of Experience"],
      helpTitle: "How Can We Help?",
      helpSubtitle: "Find quality tutors for every level, interest, and learning goal.",
      privateLesson: "Private Lessons",
      subjects: ["Preschool", "Elementary School", "Junior High School", "Senior High School", "Foreign Languages", "Computers", "Coding", "Quran Lessons", "Swimming", "University Entrance", "Music", "And More"],
      programsTitle: "Our Programs",
      programsSubtitle: "Choose a learning program that suits your needs.",
      readMore: "Read More",
      viewMore: "View More Programs",
      featuredTitle: "Our Featured Tutors",
      featuredSubtitle: "Learn with experienced, high-quality tutors selected by InstaPrivat.",
      featured: "Featured",
      subjectsLabel: "Subjects",
      curriculum: "Curriculum",
      location: "Location",
      unavailable: "Not available",
      bookNow: "Book Now",
      ctaTitle: "Ready to Improve Your Learning Results?",
      ctaText: "Register now and find the best private tutor for you. Free consultation!",
      freeConsultation: "Free Consultation",
      chat: "Chat With Us",
    },
    demo: {
      title: "Tutoring Demonstrations",
      subtitle: "See what learning with our professional tutors looks like.",
    },
    testimonials: {
      title: "What Do They Say?",
      subtitle: "9 out of 10 students are satisfied with our tutors' teaching.",
    },
    footer: {
      description: "Find the best tutors for school subjects, foreign languages, Quran lessons, university preparation, computers, coding, and many other learning needs.",
      download: "Download our app",
      connect: "Connect with us",
      follow: "Follow InstaPrivat",
      followText: "Get program updates, study tips, and the latest news.",
      validate: "Document validation",
      verify: "Verify Certificate",
      ready: "We are ready to help",
      contact: "Contact Us",
      hours: "Operating Hours",
      weekdays: "Monday–Friday, 9:00 AM–5:00 PM WIB",
      weekend: "Closed Saturday–Sunday",
      tangerang: "Tangerang Office",
      yogyakarta: "Yogyakarta Office",
      rights: "© 2020–2026. All rights reserved.",
    },
    programs: {
      loading: "Loading programs...",
      error: "Programs cannot be displayed right now.",
      empty: "No programs are available yet.",
      readMore: "Read more",
      book: "Book Now",
      whatsappMessage: "Hello InstaPrivat, I would like to book the {title} program.",
    },
    terms: {
      title: "Student Terms & Conditions",
      subtitle: "Service terms for InstaPrivat students and parents.",
      loading: "Loading terms and conditions...",
      error: "The terms and conditions cannot be displayed right now.",
    },
    certificate: {
      official: "Official InstaPrivat Service",
      title: "Certificate Verification",
      subtitle: "Confirm the authenticity of a student or tutor certificate by entering the certificate ID shown on the document.",
      security: "Verification results are displayed directly from the InstaPrivat system.",
      studentTab: "Student",
      tutorTab: "Tutor",
      studentTitle: "Student Certificate Verification",
      tutorTitle: "Tutor Certificate Verification",
      studentHint: "Enter the student certificate ID exactly as shown on the document.",
      tutorHint: "Enter the tutor certificate ID exactly as shown on the document.",
      studentId: "Student Certificate ID",
      tutorId: "Tutor Certificate ID",
      studentPlaceholder: "Example: STU-CERT-12345",
      tutorPlaceholder: "Example: TUT-CERT-12345",
      checking: "Checking...",
      verifyNow: "Verify Now",
      valid: "Valid Certificate",
      validDescription: "This certificate is officially recorded in the InstaPrivat system.",
      certificateId: "Certificate ID",
      userStudentId: "Student ID",
      userTutorId: "Tutor ID",
      totalClasses: "Total Classes",
      studentSummary: "The student has attended {count} classes with InstaPrivat.",
      tutorSummary: "The tutor has taught {count} classes with InstaPrivat.",
      notFound: "Certificate Not Found",
      studentNotFound: "No student certificate was found with ID {id}. Check the ID and try again.",
      tutorNotFound: "No tutor certificate was found with ID {id}. Check the ID and try again.",
      requestError: "Verification could not be processed. Please try again shortly.",
    },
  },
};

function getMessage(locale, key) {
  return key.split(".").reduce((value, part) => {
    if (value && Object.prototype.hasOwnProperty.call(value, part)) {
      return value[part];
    }
    return undefined;
  }, messages[locale]);
}

function interpolate(value, params) {
  if (typeof value !== "string") return value;
  return Object.keys(params || {}).reduce(
    (text, key) => text.replace(new RegExp(`\\{${key}\\}`, "g"), params[key]),
    value
  );
}

export function installI18n(Vue) {
  let storedLocale = DEFAULT_LOCALE;
  if (typeof window !== "undefined") {
    try {
      storedLocale =
        window.localStorage.getItem("instaprivat_locale") || DEFAULT_LOCALE;
    } catch (error) {
      storedLocale = DEFAULT_LOCALE;
    }
  }
  if (!messages[storedLocale]) storedLocale = DEFAULT_LOCALE;

  const state = Vue.observable({ locale: storedLocale });

  const setLocale = (locale) => {
    if (!messages[locale]) return;
    state.locale = locale;
    if (typeof window !== "undefined") {
      try {
        window.localStorage.setItem("instaprivat_locale", locale);
      } catch (error) {
        // The language still changes for this session if storage is unavailable.
      }
      document.documentElement.setAttribute("lang", locale);
    }
  };

  Vue.prototype.$localeState = state;
  Vue.prototype.$setLocale = setLocale;
  Vue.prototype.$t = function translate(key, params = {}) {
    const value = getMessage(state.locale, key);
    const fallback = getMessage("id", key);
    return interpolate(value === undefined ? fallback || key : value, params);
  };

  setLocale(storedLocale);
}
